import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { processSteps, IMG } from "../data/site";
import { Seo, breadcrumbLd } from "../components/Seo";
import { PageHero, CTABand } from "../components/ui-blocks";

const Process = () => {
  return (
    <div>
      <Seo
        title="Our Process — From Vision to Installation"
        description="Our 5-step stone fabrication and installation process: consultation, material selection, measurement & planning, fabrication and installation."
        path="/process"
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Our Process", path: "/process" }])}
      />
      <PageHero
        eyebrow="Our Process"
        title="From Vision to Installation"
        subtitle="A clear, considered process that keeps your project moving from first conversation to finished surface."
        image={IMG.process}
        testid="process-hero"
      />

      <section className="section bg-white">
        <div className="container-custom max-w-3xl">
          <div className="relative border-l-2 border-neutral-200 pl-8 space-y-12">
            {processSteps.map((s) => (
              <div key={s.step} className="relative" data-testid={`process-step-${s.step}`}>
                <span className="absolute -left-[41px] top-0 w-8 h-8 rounded-full bg-[#CD1422] text-white text-xs font-semibold flex items-center justify-center">
                  {s.step}
                </span>
                <h2 className="text-2xl mb-2">{s.title}</h2>
                <p className="text-neutral-600 leading-relaxed">{s.description}</p>
              </div>
            ))}
          </div>
          <div className="mt-14">
            <Link to="/contact" className="btn btn-primary">Start Your Project <ArrowRight size={17} /></Link>
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default Process;
